<template>
    <b-sidebar id="add-edit-subject-sidebar" :visible="isAddEditSchoolSidebarActive" bg-variant="white"
      sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
      @change="(val) => $emit('update:is-add-edit-school-sidebar-active', val)">
      <template #default="{ hide }">
        <div class="
            d-flex
            justify-content-between
            align-items-center
            content-sidebar-header
            px-2
            py-1
          ">
          <h5 class="mb-0">Edit School</h5>
          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>
        <zape-gallery-model :props_hideShowModel="showImageModel" @modelClose="modelClose" @saveCategoryImage="saveImage"
          :keyForLottie="keyForLottie" />
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <validation-provider #default="validationContext" name="School Name" rules="required">
              <b-form-group label="School Name" label-for="School Name">
                <b-form-input id="School-Name" v-model="SchoolData.school_name" autofocus
                  :state="getValidationState(validationContext)" trim />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider #default="validationContext" name="Number of Staff" rules="required|numeric|min_value:1">
  <b-form-group label="Number of Staff" label-for="staff-count">
    <b-form-input id="staff-count" 
                  v-model.number="SchoolData.staff_count" 
                  type="number" 
                  min="1"
                  :state="getValidationState(validationContext)" 
                  placeholder="Enter number of staff" />

    <b-form-invalid-feedback>
      {{ validationContext.errors[0] }}
    </b-form-invalid-feedback>
  </b-form-group>
</validation-provider>

            <validation-provider #default="validationContext" name="Premium Seats" rules="required|numeric|min_value:0">
              <b-form-group label="Premium Seats" label-for="edit-premium-seats"
                description="Lowering seats below the seats in use removes premium from the most recently assigned members.">
                <b-form-input id="edit-premium-seats" v-model.number="SchoolData.premium_seats" type="number" min="0"
                  :state="getValidationState(validationContext)" placeholder="Enter number of premium seats" />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider #default="validationContext" name="Package" :rules="packageRequired ? 'required' : ''">
              <b-form-group label="Package" label-for="edit-school-package">
                <v-select id="edit-school-package" v-model="SchoolData.package_id" :options="packageOptions"
                  label="label" :reduce="option => option.id" :loading="packagesLoading"
                  :clearable="!packageRequired" placeholder="Select package" />
                <small v-if="packageRequired && !SchoolData.package_id" class="text-muted">
                  A package is required when premium seats are greater than 0.
                </small>

                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

  
            <br />
            <!-- <img style="width: 200px; height: 150px" :src="SubjectData.subject_img" alt="" /> -->
            <template v-if="getFileExtensionFromUrl(SchoolData.school_img) == 'json'">
              <LottieView :url="SchoolData.school_img" :forEditTopics="true" :key="keyForLottie" />
            </template>
            <template v-else-if="getFileExtensionFromUrl(SchoolData.school_img) == 'lottie'">
              <!-- <LottieView :url="SubjectData.subject_img" :forEditTopics="true" :key="keyForLottie" /> -->
              <DoLottieView :url="SchoolData.school_img" :forEditTopics="true" :id="`subject_img_${uuidv4()}`"
                :key="keyForLottie" />
            </template>
            <template v-else>
              <img style="width: 200px; height: 150px" :src="SchoolData.school_img" />
            </template>
            <br />
            <br />
            <div class="d-flex gap-2">
              <b-button variant="primary" @click="showgalleryimage">
                <span class="d-none d-sm-inline">Image gallery</span>
              </b-button>
              <upload-image @saveUploadImage="saveUploadImage" />
            </div>
            <div class="d-flex bg-light text-light align-items px-3 py-2"
              style="position: absolute; bottom: 0%; left: 0%; width: 100%">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
                :disabled="submitbutton">
                Update
              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
                variant="outline-secondary" @click="hide">
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </template>
  <script>
  import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BCol,
    BFormFile,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import axios from "axios";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import Ripple from "vue-ripple-directive";
  import { required } from "@validations";
  import { numeric } from "vuelidate/lib/validators";
  import LottieView from "@/views/components/question/LottieView.vue";
  import DoLottieView from "@/views/components/question/DoLottieView.vue";
  import { v4 as uuidv4 } from 'uuid';
  export default {
    components: {
      ZapeGalleryModel: () => import("../../../components/Model/ZapeGalleryModel.vue"),
      UploadImage: () => import("../../../components/Model/UploadImage.vue"),
      BSidebar,
      BCol,
      BForm,
      BFormGroup,
      BFormInput,
      BFormInvalidFeedback,
      BButton,
      BFormFile,
      ValidationProvider,
      ValidationObserver,
      LottieView,
      vSelect,
      DoLottieView,
      uuidv4
    },
    directives: {
      Ripple,
    },
    model: {
      prop: "isAddEditSchoolSidebarActive",
      event: "update:is-add-edit-school-sidebar-active",
    },
    props: {
      isAddEditSchoolSidebarActive: {
        type: Boolean,
        required: true,
      },
      Editschoolid: {
        type: String,
        required: true,
      },
      Editschoolname: {
        type: String,
        required: true,
      },
      Editschoolimg: {
        type: String,
        required: true,
      },
        Editstaffcount: { type: Number, required: false },
        Editpremiumseats: { type: Number, required: false, default: 0 },
        Editpackageid: { type: String, required: false, default: null },
        Editpackagename: { type: String, required: false, default: null },

    },
    watch: {
      isAddEditSchoolSidebarActive(val) {
        if (val) {
          if (!this.packages.length) this.getPackages();
          this.resetForm();
        }
      },
      Editpremiumseats() {
        this.SchoolData.premium_seats = this.Editpremiumseats || 0;
      },
      Editpackageid() {
        this.SchoolData.package_id = this.Editpackageid || null;
      },

        Editschoolname(newVal) {
        this.SchoolData.school_name = this.Editschoolname;
      },
      Editschoolimg(newVal) {
        this.SchoolData.school_img = this.Editschoolimg;
      },
      Editschoolid(newVal) {
        this.SchoolData.school_id = this.Editschoolid;
      },
   Editstaffcount(newVal) {
    this.SchoolData.staff_count = this.Editstaffcount;
},

    },
    data() {
      return {
        required,
        SchoolData: {
          school_name: "",
          school_img: "",
          staff_count: null,
          premium_seats: 0,
          package_id: null,
        },
        orginal_name: "",
        edit_subject_data: "",
        showImageModel: false,
        keyForLottie: 0,
        packages: [],
        packagesLoading: false,
      };
    },
    computed: {
    packageRequired() {
      return Number(this.SchoolData.premium_seats) > 0;
    },
    packageOptions() {
      const options = this.packages.map((p) => ({
        ...p,
        label: [p.name, p.billing_cycle, p.country_code].filter(Boolean).join(" · "),
      }));
      // Keep the school's current package visible even if it is no longer active
      const selectedId = this.SchoolData.package_id;
      if (selectedId && !this.packagesLoading && !options.some((o) => o.id === selectedId)) {
        const name = selectedId === this.Editpackageid && this.Editpackagename ? this.Editpackagename : selectedId;
        options.unshift({ id: selectedId, label: name + " (inactive)" });
      }
      return options;
    },
     
    submitbutton() {
  return !(
      this.SchoolData.school_name.length > 0 &&
      this.SchoolData.school_img.length > 0 &&
      this.SchoolData.staff_count > 0 &&
      this.SchoolData.premium_seats !== "" &&
      this.SchoolData.premium_seats !== null &&
      Number(this.SchoolData.premium_seats) >= 0 &&
      (!this.packageRequired || !!this.SchoolData.package_id)
  );
}

    },
    created() {
      this.getPackages();
    },
  
    methods: {
      uuidv4,
      getPackages() {
        this.packagesLoading = true;
        axios
          .get(process.env.VUE_APP_API_URL + "/school/packages", {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("_t"),
            },
          })
          .then((response) => {
            this.packages = response.data.packages || [];
          })
          .catch((error) => {
            console.log("error", error);
          })
          .finally(() => {
            this.packagesLoading = false;
          });
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      getFileExtensionFromUrl(url) {
        if (!url) return '';
        const path = url.split('?')[0].split('#')[0];
        const extension = path.split('.').pop();
  
        if (extension === path) return '';
  
        return extension;
      },
  
      resetForm() {
        
        
        this.SchoolData = {

          school_name: this.Editschoolname,
          school_img: this.Editschoolimg,
          school_id: this.Editschoolid,
          staff_count: this.Editstaffcount,
          premium_seats: this.Editpremiumseats || 0,
          package_id: this.Editpackageid || null,
        };
        this.validated = false;
      },
      onSubmit() {
        // this.SubjectData.id = this.Editclassdata;
        // this.SubjectData.subject_id = this.Editsubjectid;
        // this.edit_subject_data = this.SubjectData;
        const payload = { ...this.SchoolData };
        payload.premium_seats = Number(payload.premium_seats) || 0;
        if (!payload.package_id) payload.package_id = null;
        this.$emit("clickeditschoolata", payload);
      },
      saveUploadImage(url) {
        console.log('url', url)
        this.SchoolData.school_img = url;
        this.keyForLottie += 1;
      },
      modelClose(modelState) {
        this.showImageModel = modelState;
      },
      saveImage(url) {
        this.SchoolData.school_img = url;
        this.keyForLottie += 1;
      },
      showgalleryimage() {
        this.showImageModel = true;
      },
    },
  };
  </script>
  